import { ListItemText, styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const StyledLinkItemText = styled(ListItemText)`
  text-transform: none;
`;
